import * as React from 'react';

import { UnverifiedEmailWarning } from 'src/ui/components/UnverifiedEmailWarning';
import { AppDialogs } from 'src/ui/containers/AppDialogs';
import { AppHooks } from 'src/ui/containers/AppHooks';
import { PortalNavbarWrapper } from 'src/ui/containers/navbar/PortalNavbarWrapper';
import { VoiceboxContextWrapper } from 'src/ui/containers/voicebox/VoiceboxContextWrapper';

export const App: React.VFC = () => {
  return (
    <>
      <main>
        <AppHooks />
        <UnverifiedEmailWarning />
        <VoiceboxContextWrapper>
          <PortalNavbarWrapper />
        </VoiceboxContextWrapper>
      </main>
      <AppDialogs />
    </>
  );
};
